import { render, staticRenderFns } from "./sidebar-item.vue?vue&type=template&id=3842db00&"
import script from "./sidebar-item.vue?vue&type=script&lang=ts&"
export * from "./sidebar-item.vue?vue&type=script&lang=ts&"
import style0 from "./sidebar-item.vue?vue&type=style&index=0&id=3842db00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports